import React, { useEffect, useMemo } from "react";
import RequirementSection from "../components/RequirementSection";
import { useLazyGetProductsListByProductInformationIdQuery } from "../../../../../../app/services/productAndService/productAndServiceApi";
import { useApplicationId } from "../hooks/useApplicationId";

const SectionB = () => {
    const applicationId = useApplicationId();
    const [getData, { data: products  }] = useLazyGetProductsListByProductInformationIdQuery();
    
    useEffect(() => {
        if (applicationId > 0) getData(applicationId);
    }, [applicationId]);

    const brandList = useMemo(
        () =>
            (products ?? [])
                .filter((item) => item.brandName != null)
                .map((item) => ({
                    id: item.sgbpProductDetailsId,
                    brand: item.brandName,
                    model: item.modelName,
                })),
        [products]
    );

    return <RequirementSection section="B" brandList={brandList} cardClassName="custom-evalution-table" />;
};

export default SectionB;